
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_PROCESS_MESSAGE_IS_MALFORMED,
	WS_REQUEST_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import { publishAndAwait } from '../../../app/coreSlice';

const billingSettle = async ({ accountCode, billingItemAccountCode, description }) => {

	if (typeof billingItemAccountCode === 'undefined'
		|| typeof description === 'undefined'
		|| typeof accountCode === 'undefined') {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	};

	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'ACCOUNT',
			subType: 'SETTLE_BILLING_ITEM',
			message: {
				accountCode,
				billingItemAccountCode,
				description,
			},
		},
	});

	const { processMessage, error } = request.response;

	if (!processMessage) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	};

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;

		throw new NGError({
			message: description,
			code,
			tag,
		});
	};


	return { code: billingItemAccountCode };
};

export default billingSettle;